import React, { useEffect, useState } from "react";
import { Box, Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import ListingTable from "./listing";
import BasicBreadcrumbs from "../../components/breadcrumb";
import PrivateLayout from "../../layouts/privateLayout";
import { Link } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { useApiClient } from "../../context/ApiClientContext";
import axios from "axios";
import ErrorAlert from "../../helper/errorAlert";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../helper/baseApi";
import ComponentBackdrop from "../../components/backdrop";
import ConfirmDialog from "../../helper/confirmDialog";

export const DataContext = React.createContext();

function Index() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = React.useState();
  const [pageSize, setPageSize] = React.useState();
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const [showButton, setShowButton] = React.useState(false);
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const navigate = useNavigate();


  const handleOpenConfirm = () => {
    if (selectedIds.length === 0) {
      toast.warning("Please select at least one event to delete.");
      return;
    }
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => setOpenConfirm(false);

  const fetchDataAndUpdateList = async (page) => {
    try {
      const apiUrl = `${mobileApiUrl}event/event-listing-portal`;
      const response = await api.get(apiUrl); 
      const events = response.data.data.eventList;
      const dataWithKeys = events.map((item) => ({
        ...item,
        id: item.eventId
      }));
      
      setFilteredDataList(dataWithKeys);
    } catch (error) {
      if (error?.response?.status === 404) {
        setFilteredDataList([]);
      } else {
        console.error("An error occurred:", error?.response?.statusText);
      }
    }
  };

 const handleShowButton = (ids) => {
    setSelectedIds(ids);
    setShowButton(ids.length > 0);
  };


  const handleConfirmDelete = async () => {
      setOpenBackdrop(true);
      try {
        const apiUrl = `${mobileApiUrl}employeeEvent/eventlist/delete`;

        const response = await api.delete(apiUrl, {
          data: { ids: selectedIds }
        });
  
        if (response.status === 200) {
          const deletedItems = filteredDataList.filter(item =>
            selectedIds.includes(item.id)
          );
          const deletedNames = deletedItems.map(item => item.name);
  
          toast.success(`Deleted: ${deletedNames.join(", ")}`);
  
          setFilteredDataList(prev =>
            prev.filter(item => !selectedIds.includes(item.id))
          );
          setSelectedIds([]);
        } else {
          toast.error("Failed to delete event. Please try again.");
        }
      } catch (error) {
        console.error("Delete Error:", error);
        ErrorAlert(error, navigate);
      } finally {
        setOpenBackdrop(false);
        setOpenConfirm(false);
      }
    };

  useEffect(() => {
    fetchDataAndUpdateList();
  }, []);

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <ComponentBackdrop openBackdrop={openBackdrop} />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BasicBreadcrumbs first="Event" />

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{
              width: { xs: "100%", sm: "auto" },
              alignItems: { xs: "stretch", sm: "flex-start" },
            }}
          >
          
           {showButton && (
              <Button
                variant="contained"
                size="large"
                fullWidth={isMobile}
                sx={{
                  backgroundColor: "secondary.main",
                  fontWeight: "600",
                  "&:hover": { backgroundColor: "secondary.dark" },
                  whiteSpace: "nowrap",
                }}
                onClick={handleOpenConfirm}
              >
                Delete
              </Button>
            )}
          </Stack>
        </Box>
        <ConfirmDialog
          open={openConfirm}
          onClose={handleCloseConfirm}
          onConfirm={handleConfirmDelete}
          title="Delete Event"
          message={`Are you sure you want to delete ${selectedIds.length > 1 ? "these events" : "this event"
            }?`}
          items={filteredDataList
            .filter(item => selectedIds.includes(item.id))
            .map(item => item.title)}
          confirmText="Delete"
          confirmColor="error"
        />

        <DataContext.Provider value={filteredDataList}>
          <ListingTable
            currentPage={currentPage}
            totalPage={totalPage}
            pageSize={pageSize}
            handleShowButton={handleShowButton}
          />
        </DataContext.Provider>

      </Box>
    </PrivateLayout>
  );
}

export default Index;
